import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import {Provider} from 'react-redux';
import {store} from './store/Store';
import './index.css';
import {ApiProvider} from "./ApiContext";
import {ConfigProvider, theme} from "antd";
import {DevSupport} from "@react-buddy/ide-toolbox";
import {ComponentPreviews, useInitial} from "./dev";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // <React.StrictMode>
    <ConfigProvider
        theme={{
            algorithm: theme.compactAlgorithm, // тёмная тема
            token: {
                // Фирменная бирюзовая схема AMFY (turquoise из мобильного приложения schedule)
                colorPrimary: '#00817C',
                colorLink: '#00817C',
                colorLinkHover: '#0c4644',
                colorError: '#D93025', // textDanger — кнопки разрушающего действия (удаление аккаунта)
                colorTextHeading: '#0c4644', // accent
                borderRadius: 10,
            },
        }}
    >
        <div className='App'>
            <Provider store={store}>
                <DevSupport ComponentPreviews={ComponentPreviews}
                            useInitialHook={useInitial}
                >
                    <ApiProvider/>
                </DevSupport>
            </Provider>
        </div>
    </ConfigProvider>,
);
reportWebVitals();
